import { Component, Input } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { CellRenderer, CellRendererParams } from 'app/shared/components/smart-grid/core/interfaces/cell-renderer.interface';

/**
 * Date Cell Renderer
 * Displays day and formatted date
 */
@Component({
  selector: 'app-date-cell-renderer',
  standalone: true,
  imports: [CommonModule, DatePipe],
  template: `
    <div class="text-content">
      <span class="font-semibold">{{ day }}<br></span>
      <span class="font-descrip">{{ formattedDate }}</span>
    </div>
  `,
  styles: [`
    :host {
      display: block;
      width: 100%;
    }
    .font-semibold {
      font-weight: 600;
    }
    .font-descrip {
      font-size: 0.875rem;
      color: #6b7280;
    }
  `]
})
export class DateCellRendererComponent implements CellRenderer<any, any> {
  @Input() params!: CellRendererParams<any, any>;

  constructor(private datePipe: DatePipe) {}

  get day(): string {
    return this.params?.data?.day ?? '';
  }

  get formattedDate(): string {
    const dateValue = this.params?.data?.trip?.dateHourStart;
    return dateValue ? (this.datePipe.transform(dateValue, 'dd-MM-yyyy') || '') : '';
  }
}
